// extracted by mini-css-extract-plugin
module.exports = {"container-loader":"loader-view_container-loader__1iFmF","light":"loader-view_light__3aPLq"};